module.exports = __webpack_public_path__ + "img/check-double-solid.ee3b5a87.svg";